import { FC } from 'react';
import { InlineFilter } from 'shared/components/InlineFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback } from 'shared/hooks';
import { DEFAULT_DELAY_VALUE, FILTER_WIDTH_DEFAULT_VALUE } from './constants';

interface IInlineRangeAdvancedFilterProps {
  label?: string;
  postfix?: string;
  dataTestId?: string;
  fieldWidth?: number;
  min?: number;
  max?: number;
  valueMin: number | null;
  valueMax: number | null;
  thousandsSeparator?: string;

  onMinChange: (value: number | null) => void;
  onMaxChange: (value: number | null) => void;
}

export const InlineRangeAdvancedFilter: FC<IInlineRangeAdvancedFilterProps> = ({
  fieldWidth = FILTER_WIDTH_DEFAULT_VALUE,
  min,
  max,
  valueMax,
  valueMin,
  label,
  postfix,
  dataTestId,
  thousandsSeparator,
  onMaxChange,
  onMinChange,
}) => {
  const handleMinChange = useDebouncedCallback(onMinChange, DEFAULT_DELAY_VALUE);

  const handleMaxChange = useDebouncedCallback(onMaxChange, DEFAULT_DELAY_VALUE);

  return (
    <InlineFilter width={fieldWidth} postfix={postfix} label={label} dataTestId={dataTestId}>
      <RangeInput
        min={min}
        max={max}
        valueMin={valueMin}
        valueMax={valueMax}
        thousandsSeparator={thousandsSeparator}
        onChangeMin={handleMinChange}
        onChangeMax={handleMaxChange}
      />
    </InlineFilter>
  );
};
